// @flow
import * as React from 'react';
import {
  Form, Text, TextArea,
} from 'informed';
import { Label, HeaderText } from '../Typography.jsx';
import { Button, PrimaryButton } from '../Buttons.jsx';
import DateText from '../DateText.jsx';
import DatetimeText from '../DatetimeText.jsx';
import NumericText from '../NumericText.jsx';
import Typeahead from '../Typeahead.jsx';

import styles from '../../styles/DrugDispenser.scss';

type Props = {
  handleSaveNewRow: Function,
  closeModal: Function,
  category: string,
}

class AddDrugModal extends React.Component<Props> {
  formApi: {
    getState: Function,
    setValues: Function,
    setValue: Function,
    reset: Function,
  }

  setFormApi = (formApi: Object) => {
    this.formApi = formApi;
  }

  handleSave = () => {
    const state = this.formApi.getState();
    if (state.invalid) {
      return;
    }
    if (!('quantity' in state.values)) {
      state.values.quantity = 0;
    }
    if (Object.keys(state.touched).length) {
      this.props.handleSaveNewRow(state);
    }
    this.formApi.reset();
    this.props.closeModal();
  }

  handleCancel = () => {
    this.formApi.reset();
    this.props.closeModal();
  }

  render() {
    return (
      <Form getApi={this.setFormApi} autoComplete='off'>
        <HeaderText>Adding Drug</HeaderText>
        <div>
          <div className={styles.drugInfoContainer}>
            <table className={styles.modalTable}>
              <tbody>
                <tr>
                  <td><Label>Category:</Label></td>
                  <td><Text field='category' disabled initialValue={this.props.category} /></td>
                </tr>
                <tr>
                  <td><Label>Generic name:</Label></td>
                  <td><Typeahead field='genericName' endpoint='genericName' /></td>
                </tr>
                <tr>
                  <td><Label>Proprietary name:</Label></td>
                  <td><Typeahead field='proprietaryName' endpoint='propName' /></td>
                </tr>
                <tr>
                  <td><Label>Drug class:</Label></td>
                  <td><Typeahead field='classification' endpoint='drugClass' /></td>
                </tr>
                <tr>
                  <td><Label>Type of drug:</Label></td>
                  <td><Typeahead field='type' endpoint='drugType' placeholder='e.g. tablets, syrup' /></td>
                </tr>
                <tr>
                  <td><Label>Description:</Label></td>
                  <td><Typeahead field='description' endpoint='drugDescription' placeholder='e.g. small white tablet' /></td>
                </tr>
                <tr>
                  <td><Label>Location:</Label></td>
                  <td><Typeahead field='location' endpoint='house' /></td>
                </tr>
              </tbody>
            </table>

            <table className={styles.modalTable}>
              <tbody>
                <tr>
                  <td><Label>Date Acquired:</Label></td>
                  <td><DatetimeText field='currDate' /></td>
                </tr>
                <tr>
                  <td><Label>Date Manufactured:</Label></td>
                  <td><DateText field='manufactureDate' item={{}} initEmpty /></td>
                </tr>
                <tr>
                  <td><Label>Expiration date:</Label></td>
                  <td><DateText field='expirationDate' item={{}} initEmpty /></td>
                </tr>
                <tr>
                  <td><Label>Lot number:</Label></td>
                  <td><Typeahead field='lotNumber' endpoint='lotNum' /></td>
                </tr>
                <tr>
                  <td><Label>Concentration:</Label></td>
                  <td><Typeahead field='concentration' placeholder='e.g. 5 mg/mL' endpoint='drugConcentration' /></td>
                </tr>
                <tr>
                  <td><Label>Amount per unit:</Label></td>
                  <td><Typeahead field='amountPerUnit' placeholder='e.g. 10 mL' endpoint='drugUnitAmt' /></td>
                </tr>
                <tr>
                  <td><Label>Quantity:</Label></td>
                  <td><NumericText field='quantity' /></td>
                </tr>
              </tbody>
            </table>
          </div>
          <Label>Notes: </Label><TextArea field='notes' /><br /><br />
          <div>
            <PrimaryButton onClick={this.handleSave}>Save</PrimaryButton>
            <Button onClick={this.handleCancel}>Cancel</Button>
          </div>
        </div>
      </Form>
    );
  }
}

export default AddDrugModal;



// WEBPACK FOOTER //
// ./client/src/components/pharmacyPages/AddDrugModal.jsx